import React from 'react';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';

import TablaSiniestros from './tablaSiniestros';
import LoadingOverlay from '../../../../Shared/LoadingOverlay';
import DetallesSiniestroEmpresa from './detalles/view';
import {
  setSiniestro,
  doGetSiniestroEmpresaDetailsApi,
  setshowNoDataEmpresa,
  resetDetalleSiniestroEmpresa,
} from './actions';
import { doGetDocumentBySiniestro } from '../../../Documentos/actions';
import HeaderInfo from './detalles/headerInfo';
import ModalDocumentos from '../../../Documentos/modalDocumentos';
import { push } from 'connected-react-router';
import { paths } from '../../../../../config/routes';
import jwtDecode from 'jwt-decode';

class Siniestros extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root));
    }
  };

  handleViewDetails = (row, data) => {
    this.props.dispatch(doGetSiniestroEmpresaDetailsApi(row.data));
    this.setState({ index: 1 });
    this.handleSetSiniestro(row.data);
    this.props.postTagManager(
      {
        label: 'Clic Btn: Ver detalle',
      },
      this.props.dispatch,
    );
  };

  handleBack = () => {
    this.setState({ index: 0 });
    this.props.dispatch(
      setshowNoDataEmpresa({
        showNoDataAtencionesMedicasEmpresa: false,
        showNoDataPeriodosReposoEmpresa: false,
        showNoDataEvaluacionesIncapaEmpresa: false,
        showNoDataPrestacionesEconomicasEmpresa: false,
      }),
    );
    this.props.dispatch(resetDetalleSiniestroEmpresa());
    this.props.dispatch(setSiniestro({ IdSiniestro: null }));
  };

  viewDocuments = (row) => {
    const { IdSiniestro } = row.data;
    const tipoSiniestro = row.data.TipoSiniestro;

    const data = {
      ...row.data,
      TipoSiniestro: tipoSiniestro.DescripcionTipoSiniestro,
      tipoBusqueda: 'E',
    };
    this.props.dispatch(doGetDocumentBySiniestro(IdSiniestro, data));

    this.props.postTagManager(
      {
        label: 'Clic Btn: Documentos',
      },
      this.props.dispatch,
    );
  };

  handleSetSiniestro = (data) => {
    this.props.dispatch(setSiniestro(data));
  };

  render() {
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <ModalDocumentos postTagManager={this.props.postTagManager} />
        <SwipeableViews index={this.state.index} disabled async>
          <div>
            <TablaSiniestros
              handleViewDocuments={this.viewDocuments}
              setSiniestro={this.handleSetSiniestro}
              handleViewDetails={this.handleViewDetails}
              postTagManager={this.props.postTagManager}
            />
          </div>
          <div>
            <HeaderInfo handleBack={this.handleBack} postTagManager={this.props.postTagManager} />
            <DetallesSiniestroEmpresa postTagManager={this.props.postTagManager} />
          </div>
        </SwipeableViews>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.siniestroEmpresa.isLoading || state.documentos.isLoading,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Siniestros);
